import styled from "styled-components";
import Img from "components/commons/Img";

export const Wrapper = styled.div`
  display: flex;
  width: 80px;
  height: 80px;
  cursor: pointer;
  @media (max-width: 1120px) {
    width: 60px;
    height: 60px;
  }
`;

export const Image = styled(Img)`
  display: flex;
  width: 100%;
  height: 100%;
`;
